import { render } from "./LineChart.vue?vue&type=template&id=ca617c74"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"
script.render = render

export default script